import { Favorite } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';
import { BUILD_PROFILE } from 'utils/buildProfile';

type BuildBadgeProps = {
  compact?: boolean;
};

const BuildBadge = ({ compact = false }: BuildBadgeProps) => {
  const siteName = process.env.REACT_APP_SITE_NAME?.trim() || BUILD_PROFILE.displayName;
  const label = compact ? BUILD_PROFILE.logoShort : siteName;

  return (
    <Box
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 0.75,
        px: compact ? 1.2 : 1.4,
        py: compact ? 0.45 : 0.6,
        borderRadius: 999,
        backgroundColor: BUILD_PROFILE.badgeColors.bg,
        border: `1px solid ${BUILD_PROFILE.badgeColors.border}`,
        boxShadow: '0 2px 10px rgba(25,55,74,0.12)',
      }}
    >
      <Favorite sx={{ fontSize: compact ? 15 : 17, color: BUILD_PROFILE.badgeColors.text }} />
      <Typography
        sx={{
          fontSize: compact ? '0.72rem' : '0.8rem',
          fontWeight: 800,
          letterSpacing: '0.03em',
          color: BUILD_PROFILE.badgeColors.text,
          lineHeight: 1,
          textTransform: 'uppercase',
        }}
      >
        {label}
      </Typography>
    </Box>
  );
};

export default BuildBadge;
